import { ErrorConstants } from "../constants";
import { AddStudyFailureReason } from "../models/results/add-study-result.interface";

export const getAddStudyFailure = (
  errorCode: string
): AddStudyFailureReason => {
  return errorCode === ErrorConstants.CREATE_STUDY_WITH_NAME_ALREADY_IN_USE_CODE
    ? AddStudyFailureReason.StudyNameAlreadyInUse
    : AddStudyFailureReason.Unknown;
};
